import { selectors } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { SECTION_SELECT } from './types';

const sectionSelectAction = actionCreator(SECTION_SELECT);

export const layoutSectionSelectThunkAction = (payload) => (dispatch, getState) => {
  const state = getState();
  const { section } = selectors.layout.properties(state);
  if (!section) {
    return dispatch(sectionSelectAction({ ...payload, previousSection: 'na' }));
  }
  if (payload.section !== section) {
    return dispatch(sectionSelectAction({ ...payload, previousSection: section }));
  }
  return null;
};
